import { createWidgetNormalizer } from '../create-widget-normalizer';
import {
    expandShorthandFields,
    foldButtonsWrapper,
    FORM_APPEARANCE_RULES,
    parseFieldsText,
} from '../form-shared/form-appearance.normalization';

/**
 * The normalization shared by `create_form_widget` and `update_form_widget` — identical for both,
 * since a create body and a patch carry the same field surface (only `fields`' requiredness differs,
 * and the create schema tightens that on its own).
 *
 * Every rule comes from `form-shared/`, which the payment form uses too; this widget adds none of its
 * own. Kept as its own normalizer rather than shared wholesale because the two types WILL diverge —
 * the payment form already adds price and product synonyms — and a shared normalizer would then
 * accept `price` on a subscription form.
 */
const formNormalizer = createWidgetNormalizer({
    before: [parseFieldsText, foldButtonsWrapper],
    rules: FORM_APPEARANCE_RULES,
    after: [expandShorthandFields],
    horizontalAlign: true,
});

export function normalizeFormWidgetArgs(raw: unknown): unknown {
    return formNormalizer.normalize(raw);
}
